import api from "./api.js";

export default class PaymentApi {
  static async paymentCheck(data) {
    return await api.post(`api/payment/check`, data);
  }

  static async payment(data) {
    return await api.post(`api/payment`, data);
  }

  static async getList(data) {
    return await api.get(`api/payment`, data);
  }

  static async getDetail(id) {
    return await api.get(`api/payment/${id}`);
  }

  static async refund(id) {
    return await api.patch(`api/payment/refund/${id}`);
  }

  static async membershipPayment(data) {
    return await api.post(`api/membership-info`, data);
  }

  static async membershipGetList(data) {
    return await api.get(`api/membership-history`, data);
  }

  static async membershipCancel() {
    return await api.patch(`api/membership-info/membership/cancel`);
  }

  static async getMyMemebership() {
    return await api.get(`api/membership-info/my/info`);
  }
}
